import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import React from 'react';
import { KitTemplate } from '../types/kit_template/kitTemplate';

export interface KitTemplateContextProps {
  kitTemplates: Map<string, KitTemplate>;
  setKitTemplates: (tasks: Map<string, KitTemplate>) => void;
  kitTemplatesLoading: boolean;
}

const defaultContext: KitTemplateContextProps = {
  kitTemplates: new Map(),
  setKitTemplates: () => {},
  kitTemplatesLoading: false,
};

export const KitTemplateContext = React.createContext<KitTemplateContextProps>(defaultContext);

interface KitTemplateState {
  items: Record<string, any>[];
  loading: boolean;
}

export const kitTemplateSlice = createSlice({
  name: 'kitTemplate',
  initialState: { items: [], loading: true } as KitTemplateState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    set: (state, action: PayloadAction<KitTemplate[]>) => {
      state.items = action.payload.map(p => new KitTemplate(p));
    },
    add: (state, action: PayloadAction<KitTemplate[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => new KitTemplate(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    delete: (state, action: PayloadAction<KitTemplate[]>) => {
      const idsToDelete = new Set(action.payload.map(a => a.id));
      state.items = [...state.items.filter(a => !idsToDelete.has(a.id))];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
